module.exports = __webpack_public_path__ + "img/sharebtn.54715a13.png";